import { render, staticRenderFns } from "./static-site-manage.vue?vue&type=template&id=d45337c8&scoped=true"
import script from "./static-site-manage.vue?vue&type=script&lang=js"
export * from "./static-site-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45337c8",
  null
  
)

export default component.exports